module.exports = __webpack_public_path__ + "img/waf-c.e391c9d.svg";